webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjQwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KIDwhLS0gQ3JlYXRlZCB3aXRoIE1ldGhvZCBEcmF3IC0gaHR0cDovL2dpdGh1Yi5jb20vZHVvcGl4ZWwvTWV0aG9kLURyYXcvIC0tPgoKIDxnPgogIDx0aXRsZT5iYWNrZ3JvdW5kPC90aXRsZT4KICA8cmVjdCB4PSItMSIgeT0iLTEiIHdpZHRoPSI0MDIiIGhlaWdodD0iNDAyIiBpZD0iY2FudmFzX2JhY2tncm91bmQiIGZpbGw9Im5vbmUiLz4KICA8ZyBpZD0iY2FudmFzR3JpZCIgZGlzcGxheT0ibm9uZSI+CiAgIDxyZWN0IGlkPSJzdmdfMyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgeD0iMCIgeT0iMCIgc3Ryb2tlLXdpZHRoPSIwIiBmaWxsPSJ1cmwoI2dyaWRwYXR0ZXJuKSIvPgogIDwvZz4KIDwvZz4KIDxnPgogIDx0aXRsZT5MYXllciAxPC90aXRsZT4KICA8cmVjdCBmaWxsPSIjMDAwMDAwIiBzdHJva2U9IiMwMDAiIHg9IjQwIiB5PSI0MCIgd2lkdGg9IjE2MCIgaGVpZ2h0PSIxNjAiIGlkPSJzdmdfMSIvPgogIDxyZWN0IGZpbGw9IiMwMDAwMDAiIHN0cm9rZT0iIzAwMCIgeD0iMjAxIiB5PSIyMDEiIHdpZHRoPSIxNjAiIGhlaWdodD0iMTYwIiBpZD0ic3ZnXzIiLz4KIDwvZz4KPC9zdmc+"

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Contact__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AboutPhil__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AboutPhil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_AboutPhil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Services__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Services___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Services__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/phil',
    name: 'phil',
    component: __WEBPACK_IMPORTED_MODULE_4__components_AboutPhil___default.a
  }, {
    path: '/services',
    name: 'services',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Services___default.a
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Contact___default.a
  }],
  mode: 'history'
}));

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(40),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_head__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(9);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuelidate___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_head___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      showLinksMenu: false
    };
  },

  methods: {
    toggleBurger: function toggleBurger(event) {
      this.showLinksMenu = !this.showLinksMenu;
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // data model
    };
  },

  head: {
    title: function title() {
      return {
        inner: 'Coaches',
        separator: '-'
      };
    },
    meta: [{ name: 'description', content: 'Bios for Phil Makepeace and Chris Russell, chess coaches running classes in schools around London and offering one-to-one coaching sessions.' }]
  }

});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // data model
      behalf: 'Myself',
      child: '',
      email: '',
      message: '',
      name: '',
      phone: '',
      school: '',
      triedSubmit: false,
      successfullySubmitted: false,
      failedToSubmit: false,
      domain: 'makepeacewithchess',

      onChildsBehalf: function onChildsBehalf() {
        return this.behalf === 'My child';
      },
      onSchoolsBehalf: function onSchoolsBehalf() {
        return this.behalf === 'A school';
      }
    };
  },

  head: {
    title: function title() {
      return {
        inner: 'Contact',
        separator: '-'
      };
    },
    meta: [{ name: 'description', content: 'Contact me to schedule some one-on-one chess coaching or for more information about our chess clubs in schools.' }]
  },
  methods: {
    submit: function submit(event) {
      var _this = this;

      this.triedSubmit = true;
      if (this.validates()) {
        this.$http.post('https://formspree.io/xoqkdrgb', {
          'name': this.name,
          'email': this.email,
          'behalf': this.behalf,
          'message': this.message,
          'phone': this.phone,
          'school': this.school,
          'child': this.child
        }).then(function (response) {
          _this.successfullySubmitted = true;
        }, function (errResponse) {
          _this.failedToSubmit = true;
          console.log('Failed to submit form. ' + errResponse);
        });
      } else {
        console.log('Invalid form entry, please try again.');
      }
    },
    validates: function validates() {
      return this.$v.name.required && this.$v.email.required && this.$v.email.email && this.$v.message.required;
    }
  },
  validations: {
    name: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
    },
    email: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"],
      email: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["email"]
    },
    message: {
      required: __WEBPACK_IMPORTED_MODULE_0_vuelidate_lib_validators__["required"]
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      testimonials: [{
        image: __webpack_require__(23),
        message: 'It is truly delightful when your 6 year old is able to educate you with genuine enthusiasm on his learnings during chess classes.',
        name: 'Abbi H, London'
      }, {
        image: __webpack_require__(25),
        message: 'Enthusiastic, pragmatic and reliable chess training. Having an approach based on practical advice which can be incorporated immediately into the student\'s game has benefitted me.',
        name: 'Simon H, London W13'
      }, {
        image: __webpack_require__(26),
        message: 'Genuinely enthusiastic and caring teaching. It has been tailored to the weaknesses of my game and greatly helped me improve.',
        name: 'Benjamin P, London E14'
      }, {
        image: __webpack_require__(28),
        message: 'I have found that useful quality in a teacher of being able to understand, follow and explain exactly what I want to be learning about.',
        name: 'David S, London'
      }, {
        image: __webpack_require__(30),
        message: 'I\'m always so impressed by the perfect blend of fun and professionalism … especially considering the fact that we don\'t even live on the same continent!',
        name: 'Kelly H, Toronto'
      }]
    };
  },

  head: {
    meta: [{ name: 'description', content: 'Fun and engaging chess classes in schools around London. We also provide one-on-one chess coaching to help players take their game to the next level.' }]
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      // data model
    };
  },

  head: {
    title: function title() {
      return {
        inner: 'Services',
        separator: '-'
      };
    },
    meta: [{ name: 'description', content: 'Details of the services offered by Makepeace With Chess, including chess classes in schools and one-to-one coaching.' }]
  }
});

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/CoachesPhil.c0306bb.png";

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Phil1.4b1d709.png";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Phil2.cc874bd.jpg";

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Phil3.988d3e6.png";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Phil4.24324cb.jpg";

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Phil5.77b902d.jpg";

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Phil6.977c848.png";

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Phil7.22e1d60.png";

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Phil8.1bcb05c.jpg";

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/janflyer.b9aac68.jpg";

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(17)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(37),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(19)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(39),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(38),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(41),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-2"
  }, [_vm._v("About Phil")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Phil Makepeace is an experienced and highly regarded coach who has been teaching chess full-time since 2013. He was England Under 18 Captain in 2007 having played in his first tournament at age 6. Phil is known as a combative, tactical player who loves a sacrifice.")]), _vm._v(" "), _c('p', [_vm._v("Outside of chess, Phil is a long-suffering Wycombe Wanderers supporter and thinks egg sandwiches are a sin.")]), _vm._v(" "), _c('p', [_vm._v("Since moving to London in 2009, Phil has taught chess in nearly twenty primary and secondary schools. His students have achieved tournament successes both individually and representing their schools.")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "subtitle is-4"
  }, [_vm._v("Qualifications")]), _vm._v(" "), _c('ul', {
    staticClass: "bio-list"
  }, [_c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2019")]), _vm._v("Certified by Wandsworth Council on completion of Safeguarding Children in Education course")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2014")]), _c('a', {
    attrs: {
      "href": "http://www.englishchess.org.uk/coaches/ecf-coaches/",
      "target": "_blank"
    }
  }, [_vm._v("ECF Accredited Coach")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "subtitle is-4"
  }, [_vm._v("Chess achievements")]), _vm._v(" "), _c('ul', {
    staticClass: "bio-list"
  }, [_c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2022")]), _vm._v("Chess consultant for the Hollywood film "), _c('a', {
    attrs: {
      "href": "https://m.imdb.com/name/nm13595086",
      "target": "_blank"
    }
  }, [_vm._v("Morbius")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2020")]), _vm._v("Co-founder and weekly panellist on "), _c('a', {
    attrs: {
      "href": "https://audioboom.com/channels/5017754",
      "target": "_blank"
    }
  }, [_vm._v("The Chess Pit podcast")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2017")]), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=Km8bMzCOhWc",
      "target": "_blank"
    }
  }, [_vm._v("Media and publicity manager")]), _vm._v(" at the "), _c('a', {
    attrs: {
      "href": "http://www.britishchesschampionships.co.uk/photography-2017/",
      "target": "_blank"
    }
  }, [_vm._v("British Chess Championships")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2013")]), _vm._v("Beat a Grandmaster in a slowplay game for the first time")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2010")]), _c('a', {
    attrs: {
      "href": "http://www.saund.co.uk/britbase/pgn/201007britchamp-viewer.html",
      "target": "_blank"
    }
  }, [_vm._v("Runner-up in British Under 21 Championship")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2007")]), _c('a', {
    attrs: {
      "href": "http://www.icu.ie/articles/150",
      "target": "_blank"
    }
  }, [_vm._v("England Under 18 Captain")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2006 & 2007")]), _c('a', {
    attrs: {
      "href": "http://www.sccu-chess.com/archive/champs.htm",
      "target": "_blank"
    }
  }, [_vm._v("Southern Counties Junior Champion")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2005, 2006 & 2007")]), _c('a', {
    attrs: {
      "href": "http://www.buckschess.org.uk/Individuals/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Bucks Senior Champion")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2001 - 2007")]), _vm._v("Represented the England Junior Squad in Lithuania, Czech Republic, Poland, USA and Ireland")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("Phil has held a peak ECF grade of 2195 and live "), _c('a', {
    attrs: {
      "href": "https://ratings.fide.com/card.phtml?event=413550",
      "target": "_blank"
    }
  }, [_vm._v("FIDE rating")]), _vm._v(" of 2116")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(22),
      "alt": "Phil Makepeace"
    }
  })])])])])])])
}]}

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "container testimonials has-text-centered"
  }, [_c('carousel', {
    attrs: {
      "autoplay": true,
      "autoplayTimeout": 10000,
      "autoplayHoverPause": true,
      "loop": true,
      "navigationEnabled": true,
      "paginationColor": 'white',
      "paginationActiveColor": 'white',
      "perPage": 1,
      "perPageCustom": [
        [768, 1]
      ]
    }
  }, _vm._l((_vm.testimonials), function(testimonial) {
    return _c('slide', {
      key: testimonial.name
    }, [_c('p', {
      staticClass: "testimonial"
    }, [_vm._v(_vm._s(testimonial.message))]), _vm._v(" "), _c('p', {
      staticClass: "testimonial-name"
    }, [_vm._v(_vm._s(testimonial.name))]), _vm._v(" "), _c('div', {
      staticClass: "home-pic"
    }, [_c('figure', {
      staticClass: "image testimonial-image"
    }, [_c('img', {
      attrs: {
        "src": testimonial.image,
        "alt": "Phil Makepeace"
      }
    })])])])
  }))], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container has-text-centered"
  }, [_c('p', [_vm._v("Phil Makepeace provides chess coaching for all ages including school clubs in London. I have consistently delivered fun and educational chess tuition to individuals, groups and schools since 2013.")]), _vm._v(" "), _c('p', [_vm._v("Whether you are already a serious player or just getting started, lessons will be carefully designed around your individual chess needs.")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "onclick": "location.href='http://makepeacewithchess.com/contact'"
    }
  }, [_vm._v("Get in touch!")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "onclick": "location.href='http://makepeacewithchess.com/services'"
    }
  }, [_vm._v("Services")])])
}]}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-2"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('p', [_vm._v("Leave me your details and I'll get back to you as soon as I can.")]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.successfullySubmitted && !_vm.failedToSubmit) ? _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.triedSubmit && !_vm.$v.name.required
    },
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Your name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input",
    class: {
      'is-danger': _vm.triedSubmit && !(_vm.$v.email.required && _vm.$v.email.email)
    },
    attrs: {
      "id": "email",
      "type": "text",
      "placeholder": "Your email address"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "input",
    attrs: {
      "id": "email",
      "type": "text",
      "placeholder": "Your phone number"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "behalf"
    }
  }, [_vm._v("Contacting on behalf of")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.behalf),
      expression: "behalf"
    }],
    attrs: {
      "id": "behalf"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.behalf = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Myself")]), _vm._v(" "), _c('option', [_vm._v("My child")]), _vm._v(" "), _c('option', [_vm._v("A school")]), _vm._v(" "), _c('option', [_vm._v("Other")])])])]), _vm._v(" "), (_vm.onChildsBehalf()) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "child"
    }
  }, [_vm._v("Child's name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.child),
      expression: "child"
    }],
    staticClass: "input",
    attrs: {
      "id": "child",
      "type": "text",
      "placeholder": "Your child's name"
    },
    domProps: {
      "value": (_vm.child)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.child = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.onSchoolsBehalf()) ? _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "school"
    }
  }, [_vm._v("School name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school),
      expression: "school"
    }],
    staticClass: "input",
    attrs: {
      "id": "school",
      "type": "text",
      "placeholder": "Name of the school"
    },
    domProps: {
      "value": (_vm.school)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.school = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea",
    class: {
      'is-danger': _vm.triedSubmit && !_vm.$v.message.required
    },
    attrs: {
      "id": "message",
      "type": "textarea",
      "rows": "4",
      "placeholder": "How can I help?"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit")])]) : _vm._e(), _vm._v(" "), (_vm.successfullySubmitted) ? _c('div', {
    staticClass: "success-msg"
  }, [_c('p', [_vm._v("Thanks for your message! I'll get back to you as soon as possible.")])]) : _vm._e(), _vm._v(" "), (_vm.failedToSubmit) ? _c('div', {
    staticClass: "failure-msg"
  }, [_c('p', {
    staticClass: "failure-msg-heading"
  }, [_vm._v("Sorry! Something went wrong and we were unable to submit your message.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Please see alternative contact options below:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(" - You can email me: contact at " + _vm._s(_vm.domain) + " dot com")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Note: we have seen intermittent issues with this form in the past, please do let me know if you have seen this message to help us investigate further.")])]) : _vm._e()]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v(" - Or you can send me a message on twitter: "), _c('a', {
    attrs: {
      "href": "https://twitter.com/ChessCoaches"
    }
  }, [_vm._v("@ChessCoaches")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-6"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(27),
      "alt": "Phil Makepeace British Universities' Chess Championship."
    }
  })])])
}]}

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(3)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "nav-logo-text"
  }, [_vm._v(" MAKEPEACE WITH CHESS")])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger",
    class: {
      'is-active': _vm.showLinksMenu
    },
    on: {
      "click": function($event) {
        _vm.toggleBurger()
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.showLinksMenu
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleBurger()
      }
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/phil"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleBurger()
      }
    }
  }, [_vm._v("About Phil")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/services"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleBurger()
      }
    }
  }, [_vm._v("Services")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/contact"
    },
    nativeOn: {
      "click": function($event) {
        _vm.toggleBurger()
      }
    }
  }, [_vm._v("Contact")])], 1)])])]), _vm._v(" "), (_vm.$route.path == '/') ? _c('section', {
    staticClass: "hero is-dark is-fullwidth"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section main"
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer mpwc-footer"
  }, [_vm._m(1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "content has-text-centered sticky-bottom"
  }, [_c('p', {
    staticClass: "is-size-7"
  }, [_c('span', [_vm._v("© 2018-" + _vm._s(new Date().getFullYear()) + " Makepeace With Chess Ltd.")]), _vm._v(" "), _c('span', [_vm._v("All rights reserved.")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('div', {
    staticClass: "logo-banner"
  }, [_c('h1', {
    staticClass: "title logo-text is-marginless is-paddingless"
  }, [_vm._v("MAKEPEACE"), _c('br'), _vm._v("WITH CHESS")]), _vm._v(" "), _c('img', {
    staticClass: "logo is-marginless is-paddingless",
    attrs: {
      "src": __webpack_require__(32)
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("Professional chess coaching in London")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half"
  }, [_c('h2', {
    staticClass: "subtitle"
  }, [_c('ul', {
    staticClass: "chess-list"
  }, [_c('li', [_vm._v("Chess clubs in schools")]), _vm._v(" "), _c('li', [_vm._v("One-to-one coaching")]), _vm._v(" "), _c('li', [_vm._v("Online courses")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "logo-banner"
  }, [_c('h1', {
    staticClass: "title logo-text is-marginless is-paddingless"
  }, [_vm._v("MAKEPEACE"), _c('br'), _vm._v("WITH CHESS")]), _vm._v(" "), _c('img', {
    staticClass: "logo is-marginless is-paddingless",
    attrs: {
      "src": __webpack_require__(3)
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Professional chess coaching in London")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "mailto:makepeacewithchess@gmail.com"
    }
  }, [_vm._v("makepeacewithchess@gmail.com")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "button"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "https://twitter.com/ChessCoaches",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "http://makepeacewithchess.com/contact"
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-envelope"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-5"
  }, [_c('a', {
    staticClass: "twitter-timeline",
    attrs: {
      "data-height": "360",
      "href": "https://twitter.com/ChessCoaches"
    }
  }, [_vm._v("Tweets by ChessCoaches")])])])])
}]}

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-2"
  }, [_vm._v("Services")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns is-vcentered reverse-row-order"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "subtitle is-3 service-title"
  }, [_vm._v("One-to-one coaching")]), _vm._v(" "), _c('div', {
    staticClass: "service-description"
  }, [_c('p', [_vm._v("I offer private lessons within London, or online worldwide! I will provide you with an individually tailored coaching programme of fun and engaging lessons. Check out some "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("student testimonials")]), _vm._v(" to see what you are missing.")], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("If you have the time and willingness to improve your game, one-to-one coaching is the way forward. Please get in touch to find out about my competitive rates and what's included.")])])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(24),
      "alt": "Chess clubs in schools"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "subtitle is-3 service-title"
  }, [_vm._v("Chess clubs in schools")]), _vm._v(" "), _c('div', {
    staticClass: "service-description"
  }, [_c('p', [_vm._v("I have taught in over 20 schools across London since 2013, offering children of all ages the chance to learn chess in a supportive, professional and - most importantly - fun setting. I see extra-curricular clubs as a place to develop skills that are necessary beyond the classroom. Chess offers a platform to learn about planning, problem solving, teamwork and sportsmanship.")]), _vm._v(" "), _c('p', [_vm._v("Each term I run internal club tournaments, awarding prizes including trophies for the top finishers and the most improved players. In the spring term I enter schools into the qualification rounds of the "), _c('a', {
    attrs: {
      "href": "https://www.delanceyukschoolschesschallenge.com/",
      "target": "_blank"
    }
  }, [_vm._v("Delancey UK Schools’ Chess Challenge")]), _vm._v(". In addition there are opportunities to compete in team events such as She Plays To Win, online interschool battles, and the "), _c('a', {
    attrs: {
      "href": "https://www.epsca.org.uk/npscc.html",
      "target": "_blank"
    }
  }, [_vm._v("National Primary School Championships")]), _vm._v(".")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(29),
      "alt": "One-to-one coaching"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(31),
      "alt": "Online courses"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('h3', {
    staticClass: "subtitle is-3 service-title"
  }, [_vm._v("Online courses")]), _vm._v(" "), _c('div', {
    staticClass: "service-description"
  }, [_c('p', [_vm._v("I also offer intensive group courses for adult beginners and improvers. I initially introduced them to offer parents a chance to learn alongside their children whom I already teach, but the pandemic and the release of The Queen's Gambit broadened their appeal. The next course is in early 2023. Opposite is the flyer for it. Places are limited so don't delay!")])])])])
}]}

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[11]);


// WEBPACK FOOTER //
// static/js/app.ae06210c0d216271b888.js